var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "virtual-keyboard" }, [
    _c("div", { staticClass: "keyboard-display" }, [
      _c("label", { staticClass: "keyboard-label" }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.inputText,
            expression: "inputText",
          },
        ],
        staticClass: "keyboard-input",
        attrs: { type: "text", readonly: "", placeholder: "Eingabe hier" },
        domProps: { value: _vm.inputText },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.inputText = $event.target.value
          },
        },
      }),
    ]),
    _c(
      "div",
      { staticClass: "keyboard-keys" },
      _vm._l(_vm.keyRows, function (row, rowIndex) {
        return _c(
          "div",
          { key: rowIndex, staticClass: "keyboard-row" },
          _vm._l(row, function (key) {
            return _c(
              "button",
              {
                key: key,
                class: [
                  "keyboard-key",
                  {
                    "keyboard-enter": key === "Enter",
                    "keyboard-backspace": key === "Backspace",
                    "keyboard-space": key === " ",
                    "keyboard-cancel": key === "Abbruch",
                  },
                ],
                on: {
                  click: function ($event) {
                    return _vm.handleKeyClick(key)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.getKeyLabel(key)) + " ")]
            )
          }),
          0
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }